import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';
import { RECENTS_KEY } from './useSavedMeals.js';

export { RECENTS_KEY };

export function useRecents() {
  return useQuery({
    queryKey: RECENTS_KEY,
    queryFn: async () => {
      const { data, error } = await api.GET('/me/recents');
      if (error || !data) throw new Error('Failed to load recents');
      return data;
    },
    staleTime: 30_000,
  });
}
